import { fetchUserCouponList } from '@/api';

const namespaced = true;

const state = {
	userCouponList: [],
};

const getters = {
	userCouponList(state) {
		return state.userCouponList;
	},
};

const mutations = {
	getUserCouponList(state, { page, list }) {
		if (page === undefined || list === undefined) return;

		if (page === 1) state.userCouponList = [...list];

		if (page > 1) state.userCouponList = [...state.userCouponList, ...list];
	},
	initUserCouponList(state) {
		state.userCouponList = [];
	},
};

const actions = {
	getUserCouponList({ commit }, payload) {
		return fetchUserCouponList(payload)
			.then(response => {
				commit('getUserCouponList', response.data);
				return response;
			})
			.catch(error => {
				console.dir(error);
				return error;
			});
	},
	initUserCouponList({ commit }) {
		commit('initUserCouponList');
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
